import React from "react";
import type { KeyDecision } from "../../data/caseStudies";
import { CaseStudySection } from "./CaseStudySection";
import { Prose } from "./Prose";
import { BODY, H3 } from "../../utils/typography";
type KeyDecisionsProps = {
  decisions: KeyDecision[];
};
export function KeyDecisions({
  decisions
}: KeyDecisionsProps) {
  return <CaseStudySection label="Key Decisions" data-id="element-64" data-mp="12s3tfrksy9gx">
      <ol className="space-y-16 md:space-y-20" data-id="element-65" data-mp="yqs29hma5g6m">
        {decisions.map(d => <li key={d.title} className="max-w-2xl" data-id="element-66" data-mp="yop3o972aeqa">
            <h3 className={`${H3} text-espresso`} data-id="element-67" data-mp="tqxe3ltw34p9">
              {d.title}
            </h3>
            {d.lede && <p className={`mt-4 ${BODY} font-medium text-espresso`} data-id="element-68" data-mp="otdu05aifxpe">{d.lede}</p>}
            <div className="mt-4" data-id="element-69" data-mp="jvc4p2mhr25h">
              <Prose body={d.body} data-id="element-70" data-mp="2j6wp78h2j47j" />
            </div>
            {d.closing && <p className={`mt-6 ${BODY} font-medium text-rust`} data-id="element-71" data-mp="2j4slorn3077s">{d.closing}</p>}
          </li>)}
      </ol>
    </CaseStudySection>;
}